import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BorrowerProfile, ContactInfo, HotelBrand, LoanInfo, PropertyInfo } from "../models/form-management.model";

@Injectable({
    providedIn: 'root'
})
export class FormManagementEndpointService {
    private http = inject(HttpClient);

    private readonly formManagementEndpoints = {
        submitForm: (uuid: string) => `/api/v2/forms/${uuid}/submit`,
        propertyInfo: (uuid: string) => `/api/v2/forms/${uuid}/property-info`,
        loanInfo: (uuid: string) => `/api/v2/forms/${uuid}/loan-info`,
        contactInfo: (uuid: string) => `/api/v2/forms/${uuid}/contact-info`,
        borrowerProfile: (uuid: string) => `/api/v2/forms/${uuid}/borrower-profile`,
        initiateForm: `/api/v2/forms/initiate`,
        formExist: (uuid: string) => `/api/v2/forms/${uuid}/exists`,
        validateEmail: `/api/v2/forms/validation/disposable-email`,
        getHotelBrands: `/api/v2/forms/hotel-brands`,
    }

    submitForm(uuid: string, formData: FormData) {
        return this.http.post(this.formManagementEndpoints.submitForm(uuid), formData);
    }

    getPropertyInfo(uuid: string) {
        return this.http.get<PropertyInfo>(this.formManagementEndpoints.propertyInfo(uuid));
    }

    updatePropertyInfo(uuid: string, body: PropertyInfo) {
        return this.http.post(this.formManagementEndpoints.propertyInfo(uuid), body);
    }

    getLoanInfo(uuid: string) {
        return this.http.get<LoanInfo>(this.formManagementEndpoints.loanInfo(uuid));
    }

    updateLoanInfo(uuid: string, body: LoanInfo) {
        return this.http.post(this.formManagementEndpoints.loanInfo(uuid), body);
    }

    getContactInfo(uuid: string) {
        return this.http.get<ContactInfo>(this.formManagementEndpoints.contactInfo(uuid));
    }

    updateContactInfo(uuid: string, body: ContactInfo) {
        return this.http.post(this.formManagementEndpoints.contactInfo(uuid), body);
    }

    getBorrowerProfile(uuid: string) {
        return this.http.get<BorrowerProfile>(this.formManagementEndpoints.borrowerProfile(uuid));
    }

    updateBorrowerProfile(uuid: string, body: BorrowerProfile) {
        return this.http.post(this.formManagementEndpoints.borrowerProfile(uuid), body);
    }
    
    initiateForm(email: string) {
        return this.http.post<{uuid: string}>(this.formManagementEndpoints.initiateForm, {}, {
            params: { email }
        });
    }

    formExist(userUuid: string) {
        return this.http.get<{ exists: boolean }>(this.formManagementEndpoints.formExist(userUuid));
    }
    
    validateEmail(email: string) {
        return this.http.get<boolean>(this.formManagementEndpoints.validateEmail, {
            params: { email }
        });
    }

    getHotelBrands() {
        return this.http.get<HotelBrand[]>(this.formManagementEndpoints.getHotelBrands);
    }
}